import * as appHelp from './app-help';
import * as toolboxHelp from './toolbox-help';
import * as llcHelp from './llc-help';
import * as measureToolHelp from './measure-tool-help';
import * as printToolHelp from './print-tool-help';
import * as weatherStationHelp from './weather-station-help';
import * as weatherDataHelp from './weather-data-help';
import * as wildfireHelp from './wildfire-help';
import * as dutyLogHelp from './duty-log-help';
import * as varHelp from './var-help';
import * as lightningHelp from './lightning-help';
import * as affHelp from './aff-help';
import * as layerDrawerHelp from './layer-drawer-help';
import * as cffdrsHelp from './cffdrs-help';
import * as gisDownloadHelp from './gis-download-help';
import * as reissueHelp from './reissue-help';
import * as fireModelingHelp from './fire-modeling-help';
import * as permissionManagerHelp from './permission-manager-help';
import * as auditLogHelp from './audit-log-help';
import * as stationFormHelp from './station-form-help';
import * as themeHelp from './theme-help';
import * as hotspotHelp from './hotspot-help';
import * as rfbfHelp from './rfbf-help';
import * as savedMapHelp from './saved-map-help';

interface HelpModule {
  helpTitle: string;
  helpContent: string;
}

export const helpModules: { [key: string]: HelpModule } = {
  'app-help': appHelp,
  'toolbox-help': toolboxHelp,
  'llc-help': llcHelp,
  'measure-tool-help': measureToolHelp,
  'print-tool-help': printToolHelp,
  'weather-station-help': weatherStationHelp,
  'weather-data-help': weatherDataHelp,
  'wildfire-help': wildfireHelp,
  'duty-log-help': dutyLogHelp,
  'var-help': varHelp,
  'lightning-help': lightningHelp,
  'aff-help': affHelp,
  'layer-drawer-help': layerDrawerHelp,
  'cffdrs-help': cffdrsHelp,
  'gis-download-help': gisDownloadHelp,
  'reissue-help': reissueHelp,
  'fire-modeling-help': fireModelingHelp,
  'permission-manager-help': permissionManagerHelp,
  'audit-log-help': auditLogHelp,
  'station-form-help': stationFormHelp,
  'theme-help': themeHelp,
  'hotspot-help': hotspotHelp,
  'saved-map-help': savedMapHelp,
  // rfbf-help's content depends on FWI classifications loaded from backend on
  // app boot; wrap with a getter so the modal sees the current list each open.
  'rfbf-help': {
    get helpTitle() { return rfbfHelp.helpTitle; },
    get helpContent() { return rfbfHelp.buildHelpContent(); },
  },
};
